import React from 'react';

function AchievementsPanel({ achievements, cards = [] }) {
  const unlockedCards = Array.isArray(cards) ? cards.filter(card => card.unlocked) : [];
  const inProgressCards = Array.isArray(cards) ? cards.filter(card => !card.unlocked) : [];
  const hasStructuredCards = unlockedCards.length > 0 || inProgressCards.length > 0;

  return (
    <div className="completed-section">
      <h3>🏅 Achievements</h3>
      {hasStructuredCards ? (
        <div className="completed-list">
          {unlockedCards.slice().reverse().slice(0, 8).map((card) => (
            <div key={card.id} className="completed-item" title={`${card.category} • ${card.tier}`}>
              {card.title}
            </div>
          ))}
          {inProgressCards.slice(0, 3).map((card) => (
            <div key={card.id} className="completed-item completed-item--locked" title={`${card.progress}/${card.target}`}>
              {card.title} ({card.progress}/{card.target})
            </div>
          ))}
        </div>
      ) : Array.isArray(achievements) && achievements.length > 0 ? (
        <div className="completed-list">
          {achievements.slice().reverse().slice(0, 8).map((achievement, index) => (
            <div key={`${achievement}-${index}`} className="completed-item">
              {achievement}
            </div>
          ))}
        </div>
      ) : (
        <p className="no-tasks">Complete tasks and sync Google Fit data to unlock achievements.</p>
      )}
    </div>
  );
}

export default AchievementsPanel;
